import { Helmet } from "react-helmet-async";
import {
  Banner,
  AboutUsSection,
  CtaButtonsSection,
  OfficeStylesSection,
  CitiesSection,
  JoinTheCommunitySection,
  ReviewsSection,
  OtherLinksSection,
  Partners,
  BlogAndNewsletter,
} from "./components";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

import "./styles.scss";

const HomePage = () => {
  const [t, i18n] = useTranslation("global");

  // Get current language
  const currentLanguage = i18n.language || 'fr';

  // Get translations for meta data
  const metaTitle = t("home.headTitle");
  const metaDescription = t("home.metaDescription");
  const metaKeywords = t("home.metaKeywords");

  // Get current canonical URL
  const currentPath = window.location.pathname;
  const baseUrl = "https://chooseandwork.com";
  const canonicalUrl = `${baseUrl}${currentPath}`;

  // Open Graph image (can be replaced with your actual OG image)
  const ogImage = "https://chooseandwork.com/og-image-home.jpg";
  const twitterImage = "https://chooseandwork.com/twitter-image-home.jpg";

  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta name="keywords" content={metaKeywords} />
        <link rel="canonical" href={canonicalUrl} />
        
        {/* Open Graph Tags */}
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={ogImage} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:locale" content={currentLanguage === 'fr' ? 'fr_FR' : currentLanguage === 'en' ? 'en_US' : 'es_ES'} />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={metaTitle} />
        <meta name="twitter:description" content={metaDescription} />
        <meta name="twitter:image" content={twitterImage} />
        
        {/* Additional meta tags */}
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
      </Helmet>

      <div className="home">
        <Banner />
        <Partners />
        {/* <CtaButtonsSection /> */}
        <CitiesSection />
        <AboutUsSection />
        <OfficeStylesSection />
        <JoinTheCommunitySection/>
        <BlogAndNewsletter/>
        {/* <OtherLinksSection /> */}
        {/* <ReviewsSection />} */}
      </div>
    </>
  );
};

export default HomePage;